<template>
    <div>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col"><h3 class="mb-0">Menu</h3></div>
                                <div class="col text-right">
                                    <a class="btn btn-icon btn-primary btn-sm" href="/menu/add"><span class="btn-inner--icon" style="margin-right:5px"><i class="fad fa-layer-plus"></i></span>Nové menu</a>
                                </div>
                            </div>
                        </div>
                        <a-modal :title="'Preklad menu ' + newTranslation.orititle" contentClassName="manager" class="builder-content" v-model="visible" @ok="handleOk">
            <a-form-item   label="Názov" type="inline" class="mb-0">
            <a-input type="text" v-model="newTranslation.title"></a-input>
            </a-form-item>
            <a-form-item   label="Slug" type="inline" class="mb-0">
            <a-input type="text"  v-model="newTranslation.slug"></a-input>
            </a-form-item>
            <a-form-item  label="Jazyk" type="inline" class="mb-0">
                <a-select v-model="newTranslation.language" class="w-100">
                    <template v-for="i in languages">
                        <a-select-option v-if="i.short != newTranslation.orilang" :key="i.short">{{i.title}}</a-select-option>
                    </template>
                </a-select>
    </a-form-item>
    <a-form-item  label="AI" type="inline">
        <a-checkbox label="Automatický preklad" v-model="newTranslation.auto">Automatický preklad cez AI</a-checkbox>
    </a-form-item>

        </a-modal>

                        <div class="table-responsive">
                            <a-table
                                    :columns="columns"
                                    :rowKey="record => record.id"
                                    :dataSource="data"
                                    :loading="loading"
                                    class="table-flush">
                                <template slot="name" slot-scope="permission">

                                    <router-link :to="'/menu/' + permission.id" :href="'/menu/' + permission.id"><a-button class="mr-2">Upraviť</a-button></router-link>
                                    <a-button class="mr-2" @click="translateMenu(permission)">Preložiť</a-button>
                                    <router-link :href="'/menu-items/' + permission.id" :to="'/menu-items/' + permission.id"><a-button class="mr-2">Položky menu</a-button></router-link>
                                    <router-link :href="'/menu-items-reorder/' + permission.id" :to="'/menu-items-reorder/' + permission.id"><a-button class="mr-2">Preusporiadať</a-button></router-link>

                                      <a-popconfirm placement="topRight"
                                                  @confirm="confirm(permission.id)"
                                                  @cancel="cancel"
                                                  okText="Áno"
                                                  cancelText="Nie">
                                        <template slot="title">
                                            <h5 color="danger" >Prajete si tento obsah vymazať?</h5>
                                            Položka bude trvalo odstránená z vašej stránky.
                                        </template>
                                        <a-button type="secondary" icon="fas fa-trash"    textColor="default" title="Zmazať">Zmazať</a-button>
                                    </a-popconfirm>
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {dataService} from "../../_services";
    import {Popconfirm} from "ant-design-vue"

    const columns = [
        {
            title: 'Názov menu',
            dataIndex: 'title',
            sorter: true,
            width: '20%',
        },
        {
            title: 'slug',
            dataIndex: 'slug',
        },
        {
            align: 'right',
            scopedSlots: {customRender: 'name'},
        }
    ];

    export default {
        name: "menu",
        components: {
            "a-popconfirm": Popconfirm
        },
        data() {
            return {
                data: [],
                colorsto: JSON.parse(localStorage.colors),
                loading: false,
                columns,
                newTranslation: {},
                visible:false,
                translations:[],
                languages:[],
                defaultLanguage:""
            };
        },
        mounted() {
            this.fetch();

            dataService.axiosFetch('languages').then(results => {
                this.languages = results;
                results.forEach(obj => {
                    if(obj.def === "1")
                    this.defaultLanguage = obj.short;
                    this.translations[obj.short] = {};
                });

            });

        },
        methods: {
            confirm(e) {
                dataService.axiosDelete(this.$options.name, e).then(results => {
                    if (results) {
                        this.data.splice(this.data.findIndex(x => parseInt(x.id) === parseInt(e)), 1);
                    }
                });
            },
            cancel() {
            },
            handleOk()
            {
                dataService.axiosPost("translatemenu", this.newTranslation).then(results => {
                    if (results) {
                        this.fetch();
                        this.visible = false;
                    } else {
                        this.$message.error("Pri preklade nastala chyba.");
                    }
                });
            },
            translateMenu(e)
            {
console.log(e);
                this.newTranslation.id = e.id;
                this.newTranslation.orititle = e.title;
                this.newTranslation.orilang = e.language;
                this.visible = true;
            },
            fetch() {
                this.loading = true;
                dataService.axiosFetch(this.$options.name).then(results => {
                    this.data = results;
                    this.loading = false;
                });
            }

        },
    };
</script>

<style>
    ul.ant-pagination {
        margin-top: 0;
        margin-bottom: 1em;
    }


    .ant-table-pagination.ant-pagination {
        margin-bottom: 40px;
        margin-right: 20px;
    }

    .ant-pagination5-item {
        border: 0;
    }

    .ant-table {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        margin-bottom: 20px;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a, .ant-pagination5-jump-prev a, .ant-pagination5-jump-next a {
        -webkit-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        border: 0;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 0;
        margin: 0 3px;
        border-radius: 50% !important;
        width: 36px;
        height: 36px;
        font-size: 0.875rem;
    }


    .ant-pagination5-item.ant-pagination5-item-active a {
        z-index: 1;
        color: #fff;
        background-color: #5e72e4;
        border-color: #5e72e4;
    }

    .ant-pagination5-item-link.ant-pagination5-disabled a {
        color: #8898aa;
        pointer-events: none;
        cursor: auto;
        background-color: #fff;
        border-color: #dee2e6;
    }

</style>
